"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _apiClient = _interopRequireDefault(require("hub-http/clients/apiClient"));

var _ManagerWithSession2 = _interopRequireDefault(require("./ManagerWithSession"));

var COMPOSITION_BASE_URI = 'composition/v1/compositions';
var COMPOSITION_FETCH_TIMEOUT = 15000;

var getCompositionURI = function getCompositionURI(id) {
  return COMPOSITION_BASE_URI + "/" + id;
};

var applyDefaultOptions = function applyDefaultOptions() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return Object.assign({
    safeMode: true
  }, options);
};

var CompositionManager = /*#__PURE__*/function (_ManagerWithSession) {
  (0, _inherits2.default)(CompositionManager, _ManagerWithSession);

  function CompositionManager() {
    (0, _classCallCheck2.default)(this, CompositionManager);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(CompositionManager).apply(this, arguments));
  }

  (0, _createClass2.default)(CompositionManager, [{
    key: "fetchFullComposition",
    value: function fetchFullComposition(id) {
      var _this = this;

      var options = {
        query: {
          session: this.session
        },
        timeout: COMPOSITION_FETCH_TIMEOUT
      };
      var url = getCompositionURI(id) + "/all";
      return _apiClient.default.get(url, options).then(function (resp) {
        resp.composition.lockedSession = _this.session;
        return resp;
      });
    }
  }, {
    key: "updateComposition",
    value: function updateComposition(data) {
      var query = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var options = applyDefaultOptions({
        data: data,
        query: query
      });
      return _apiClient.default.put(getCompositionURI(data.get('id')), options);
    }
  }, {
    key: "createComposition",
    value: function createComposition(data) {
      var query = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var options = applyDefaultOptions({
        data: data,
        query: query
      });
      return _apiClient.default.post(COMPOSITION_BASE_URI, options);
    }
  }, {
    key: "fetchRevisions",
    value: function fetchRevisions(id, offset) {
      var url = getCompositionURI(id) + "/versions-counted";
      var query = {
        offset: offset
      };
      return _apiClient.default.get(url, {
        query: query
      });
    }
  }, {
    key: "revertToRevision",
    value: function revertToRevision(data) {
      var url = getCompositionURI(data.get('compositionId')) + "/versions/restore";
      var options = applyDefaultOptions({
        data: data
      });
      return _apiClient.default.post(url, options);
    }
  }]);
  return CompositionManager;
}(_ManagerWithSession2.default);

exports.default = CompositionManager;
module.exports = exports.default;